import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  schema?: object;
}

export function useSEO(props: SEOProps) {
  const location = useLocation();

  useEffect(() => {
    // Update title
    if (props.title) {
      document.title = props.title;
    }

    // Update meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    if (props.description) {
      updateMetaTag('description', props.description);
      updateMetaTag('og:description', props.description, true);
      updateMetaTag('twitter:description', props.description);
    }

    if (props.keywords) {
      updateMetaTag('keywords', props.keywords);
    }

    if (props.ogImage) {
      updateMetaTag('og:image', props.ogImage, true);
      updateMetaTag('twitter:image', props.ogImage);
    }

    // Update canonical
    if (props.canonical) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', props.canonical);
      updateMetaTag('og:url', props.canonical, true);
    }

    // Add or update Schema.org JSON-LD
    if (props.schema) {
      const schemaId = 'dynamic-schema-org';
      let schemaScript = document.getElementById(schemaId);
      
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.id = schemaId;
        schemaScript.type = 'application/ld+json';
        document.head.appendChild(schemaScript);
      }
      
      schemaScript.textContent = JSON.stringify(props.schema);
    }

    // Update last-modified
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    }
  }, [location.pathname, props]);
}

export function generateProductSchema(siteUrl: string) {
  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "LELO SONA 2 Cruise",
    "image": `https://public.readdy.ai/ai/img_res/999fa74a7e01943dce86858e6a27528a.jpg`,
    "description": "Estimulador clitoral de lujo con tecnología sónica revolucionaria. Sin contacto directo, diseño sueco premium y silicona médica.",
    "brand": {
      "@type": "Brand",
      "name": "LELO"
    },
    "offers": {
      "@type": "Offer",
      "url": siteUrl,
      "priceCurrency": "EUR",
      "price": "149.00",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "Conejox"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "2847"
    }
  };
}

export function generateFAQSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Hace mucho ruido?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Su tecnología sónica es casi silenciosa, perfecta para tu privacidad e intimidad."
        }
      },
      {
        "@type": "Question",
        "name": "¿Puedo usarlo en la ducha?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí, es resistente al agua al 100%. Disfruta de momentos de placer en la bañera o la ducha sin preocupaciones."
        }
      },
      {
        "@type": "Question",
        "name": "¿Es seguro para el cuerpo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Totalmente. Hecho con silicona médica premium, libre de ftalatos y completamente hipoalergénico."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto dura la batería?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Hasta 2 horas de placer continuo con una sola carga. Recargable por USB para tu comodidad."
        }
      }
    ]
  };
}

export function generateWebPageSchema(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "LELO SONA 2 Cruise – Succionador de clítoris de lujo | Conejox",
    "description": "Explora un nuevo nivel de placer con SONA 2 Cruise. Tecnología sónica sin contacto directo, diseño elegante y orgasmos profundos.",
    "url": siteUrl,
    "inLanguage": "es",
    "publisher": {
      "@type": "Organization",
      "name": "Conejox",
      "url": "https://conejox.com.es"
    }
  };
}
